import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StarIcon = ({ filled, half }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="halfGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="50%" stopColor="#FBBF24" />
        <stop offset="50%" stopColor="#374151" />
      </linearGradient>
    </defs>
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      fill={half ? "url(#halfGrad)" : filled ? "#FBBF24" : "#374151"}
      stroke={filled || half ? "#FBBF24" : "#4B5563"}
      strokeWidth="0.5"
    />
  </svg>
);

const GoogleReviews = () => {
  const rating = 4.9;
  const totalReviews = 116;

  const reviews = [
    // { name: "Priya S.", text: "Absolutely stunning frames! The quality exceeded my expectations.", stars: 5, time: "2 weeks ago" },
    // { name: "Rahul M.", text: "Fast delivery and the personalization was perfect. Highly recommend!", stars: 5, time: "1 month ago" },
    // { name: "Anitha K.", text: "Beautiful craftsmanship. My family loved the gift.", stars: 5, time: "3 weeks ago" },
  ];

  const [hoveredReview, setHoveredReview] = useState(null);

  return (
    <div style={{ marginTop: '8px' }}>
      {/* Google Badge */}
      <div style={{
        display: 'inline-flex', alignItems: 'center', gap: '10px',
        background: 'linear-gradient(135deg, #1e1e1e, #2a2a2a)',
        border: '1px solid #333', borderRadius: '14px',
        padding: '12px 18px', marginBottom: '20px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
      }}
      
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,0,0,0.5)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.4)'; }}
      >
        {/* Google G Logo */}
        <svg width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>

        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ fontSize: '18px', fontWeight: 800, color: '#fff', lineHeight: 1 }}>{rating}</span>
            <div style={{ display: 'flex', gap: '2px' }}>
              {[1, 2, 3, 4, 5].map(i => (
                <StarIcon key={i} filled={i <= Math.floor(rating)} half={i === Math.ceil(rating) && rating % 1 !== 0} />
              ))}
            </div>
          </div>
          <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>
            {totalReviews} Google Reviews
          </div>
        </div>
      </div>

      {/* Review Cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {reviews.map((review, i) => (
          <div key={i}
            onMouseEnter={() => setHoveredReview(i)}
            onMouseLeave={() => setHoveredReview(null)}
            style={{
              background: hoveredReview === i ? '#242424' : '#1e1e1e',
              border: `1px solid ${hoveredReview === i ? '#f97316' : '#2a2a2a'}`,
              borderRadius: '12px', padding: '12px 14px',
              transition: 'all 0.2s ease',
              cursor: 'default',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  width: '30px', height: '30px', borderRadius: '50%',
                  background: 'linear-gradient(135deg, #f97316, #ea580c)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '13px', fontWeight: 700, color: '#fff', flexShrink: 0,
                }}>
                  {review.name[0]}
                </div>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: 600, color: '#e5e7eb' }}>{review.name}</div>
                  <div style={{ display: 'flex', gap: '2px', marginTop: '2px' }}>
                    {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} filled={s <= review.stars} />)}
                  </div>
                </div>
              </div>
              <span style={{ fontSize: '10px', color: '#6b7280', whiteSpace: 'nowrap' }}>{review.time}</span>
            </div>
            <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af', lineHeight: '1.5' }}>
              "{review.text}"
            </p>
          </div>
        ))}
      </div>

  
    </div>
  );
};

const Footer = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email && formData.message) {
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
      setFormData({ name: '', email: '', message: '' });
    }
  };

  return (
    <footer style={{ background: '#1a1a1a', color: '#fff', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Main Footer Content */}
      <div className="gridfooter" style={{
        maxWidth: '1200px', margin: '0 auto', padding: '60px 24px 40px',
        display: 'grid', gap: '48px'
      }}>

        {/* Brand Column — now with Google Reviews */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
            <span style={{
              fontSize: '26px', fontWeight: 800,
              background: 'linear-gradient(135deg, #f97316, #ea580c)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
            }}>
              shaart
            </span>
          </div>
          <p style={{ color: '#9ca3af', fontSize: '14px', lineHeight: '1.7', marginBottom: '24px' }}>
            Personalized frames crafted with love. Upload your memories and let us turn them into art that lasts a lifetime.
          </p>

          {/* Google Reviews — replaces social icons */}
          <GoogleReviews />
        </div>

        {/* Quick Links */}
        <div>
          <h4 style={{ fontSize: '15px', fontWeight: 700, color: '#fff', marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Quick Links
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {[
              { label: 'Home', path: '/' },
              { label: 'My Orders', path: '/my-orders' },
              { label: 'Favourites', path: '/favourites' },
              { label: 'Checkout', path: '/checkout' },
            ].map((link) => (
              <li key={link.label}>
                <span
                  onClick={() => { navigate(link.path); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  style={{ color: '#9ca3af', fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#f97316'}
                  onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
                >
                  <span style={{ color: '#f97316', fontSize: '10px' }}>▶</span>
                  {link.label}
                </span>
              </li>
            ))}
          </ul>

          {/* Contact Info */}
          <h4 style={{ fontSize: '15px', fontWeight: 700, color: '#fff', margin: '28px 0 16px', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Contact Info
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {[
              { icon: 'fas fa-phone-alt', text: '04651 - 250-827' },
              { icon: 'fas fa-mobile-alt', text: '8903-8010-89' },
              { icon: 'fas fa-map-marker-alt', text: 'Karungal, Palappallam, Kattukadai, Tamil Nadu – 629159' },
            ].map((c, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#9ca3af', fontSize: '13px' }}>
                <i className={c.icon} style={{ color: '#f97316', width: '16px', textAlign: 'center' }} />
                {c.text}
              </div>
            ))}
          </div>
        </div>

        {/* Contact Form */}
        <div>
          <h4 style={{ fontSize: '15px', fontWeight: 700, color: '#fff', marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Send Us a Message
          </h4>

          {submitted ? (
            <div style={{
              background: 'rgba(249,115,22,0.12)', border: '1px solid #f97316',
              borderRadius: '12px', padding: '20px', textAlign: 'center', color: '#f97316', fontWeight: 600
            }}>
              ✅ Message sent! We'll get back to you soon.
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <input
                type="text" name="name" placeholder="Your Name"
                value={formData.name} onChange={handleChange} required
                style={{ background: '#2a2a2a', border: '1.5px solid #333', borderRadius: '10px', padding: '11px 14px', color: '#fff', fontSize: '13px', outline: 'none', transition: 'border-color 0.2s' }}
                onFocus={e => e.target.style.borderColor = '#f97316'}
                onBlur={e => e.target.style.borderColor = '#333'}
              />
              <input
                type="email" name="email" placeholder="Your Email"
                value={formData.email} onChange={handleChange} required
                style={{ background: '#2a2a2a', border: '1.5px solid #333', borderRadius: '10px', padding: '11px 14px', color: '#fff', fontSize: '13px', outline: 'none', transition: 'border-color 0.2s' }}
                onFocus={e => e.target.style.borderColor = '#f97316'}
                onBlur={e => e.target.style.borderColor = '#333'}
              />
              <textarea
                name="message" placeholder="Your Message"
                value={formData.message} onChange={handleChange} required rows={4}
                style={{ background: '#2a2a2a', border: '1.5px solid #333', borderRadius: '10px', padding: '11px 14px', color: '#fff', fontSize: '13px', outline: 'none', resize: 'vertical', transition: 'border-color 0.2s', fontFamily: 'inherit' }}
                onFocus={e => e.target.style.borderColor = '#f97316'}
                onBlur={e => e.target.style.borderColor = '#333'}
              />
              <button type="submit" style={{ background: 'linear-gradient(135deg, #f97316, #ea580c)', color: '#fff', border: 'none', borderRadius: '10px', padding: '12px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', letterSpacing: '0.3px' }}>
                Send Message →
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Divider */}
      <div style={{ borderTop: '1px solid #2a2a2a', maxWidth: '1200px', margin: '0 auto' }} />

      {/* Footer Bottom */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <p style={{ margin: 0, color: '#6b7280', fontSize: '13px' }}>
          © 2026 <span style={{ color: '#f97316', fontWeight: 700 }}>Shaart</span> All Rights Reserved.
        </p>
        <div style={{ display: 'flex', gap: '20px' }}>
          {['Privacy Policy', 'Terms of Service'].map((item) => (
            <span key={item} style={{ color: '#6b7280', fontSize: '12px', cursor: 'pointer', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#f97316'}
              onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}
            >
              {item}
            </span>
          ))}
        </div>
      </div>

    </footer>
  );
};

export default Footer;